import { faMinus, faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import { openCloseModalRoleReducer } from '../../../redux/slices/components/ManageRoles/manageRolesSlice';
import { useAppDispatch } from '../../../redux/store/store';
import useCheckAccess from '../../hooks/useCheckAccess/useCheckAccess';

const HeaderManageRoles = () => {

    const { t } = useTranslation();
    const dispatch = useAppDispatch()

    const accessEditRole = useCheckAccess({ id_Category: "Manage_Roles", id_Policy: "Roles", id_Action: "Edit" })
    const accessDeleteRole = useCheckAccess({ id_Category: "Manage_Roles", id_Policy: "Roles", id_Action: "Delete" })

    const handleAddNewRole= () => {
        dispatch( openCloseModalRoleReducer("Add") )
    }

    const handleRemoveRole= () => {
        dispatch( openCloseModalRoleReducer("Remove") )
    }


    return (
        <div className="flex flex-ai-center pb-6">
            <p className="title-screen">{t("General:label_046")}</p>
            {
                accessEditRole &&
                <button 
                    className="btn-beside-title-screen"
                    onClick={handleAddNewRole}
                >
                    <FontAwesomeIcon icon={faPlus} className="fs-18" />
                    <p className="text-btn-title-screen">{t("General:label_239")}</p>
                </button>
            }
            {
                accessDeleteRole &&
                <button 
                    className="btn-beside-title-screen"
                    onClick={handleRemoveRole}
                >
                    <FontAwesomeIcon icon={faMinus} className="fs-18" />
                    <p className="text-btn-title-screen">{t("General:label_240")}</p>
                </button>
            }
        </div>
    )
}

export default HeaderManageRoles